import React, {Fragment} from 'react';
import {Link, Form, Slider, Breadcrumbs, Card, Button, Layout} from 'components';
import {debounce, keyBy, mapValues, useNamedSelector} from 'helpers';
import {store} from 'store';
import css from './mood-meter.module.scss';

export function MiddayMoodMeter() {
  return (
    <Fragment>
      <Layout.Header justified>
        <Breadcrumbs>
          <Link to="/diary/">Journal</Link>
          <b>Mood meter</b>
        </Breadcrumbs>
        <Button className={['primary', 'small']} to="/diary/" icon="check">Complete</Button>
      </Layout.Header>
      <div>
        <MoodMeter date={useNamedSelector('calendar.days').today.unix()} />
      </div>
    </Fragment>
  );
}

export function MoodMeter({ date }) {
  const { today } = useNamedSelector('calendar.days');
  const { diaryId, emotions, emotionsMeterId } = useNamedSelector('diary.moodByDate', { date });

  const values = {
    ...mapValues(keyBy(emotions, 'key'), 'value'),
    date,
    diaryId,
    emotionsMeterId,
  }

  return (
    <Form className="medium-spacing" initialValues={values} onChange={save}>
      <Card>
        <Card.Body>
          <p>
            { today.unix() == date
              ? <b className="label">How do you feel right now?</b>
              : <b className="label">How did you feel?</b>
            }
          </p>
          <div className={css.grid}>
            { emotions.map(line =>
              <Fragment key={line.key}>
                <span>{ line.bad }</span>
                <Slider name={line.key} max={10} filled="colored" />
                <span>{ line.good }</span>
              </Fragment>
            ) }
          </div>
        </Card.Body>
      </Card>
    </Form>
  );
}

const save = debounce(values => {
  const { emotionsMeterId, date, diaryId, ...fields } = values;
  store.dispatch({
    type: 'DIARY_MOOD_CHANGE',
    diaryId,
    mood: {
      ...fields,
      date,
      id: emotionsMeterId,
    }
  });
}, 250);
